type ApiErrorBody = {
  message?: string;
  error?: string;
  details?: string;
  errors?: Array<{ msg?: string; message?: string }>;
};

function getValidationMessages(data: ApiErrorBody): string[] {
  if (!Array.isArray(data.errors)) return [];

  return data.errors
    .map((entry) => entry?.msg || entry?.message)
    .filter((msg): msg is string => typeof msg === 'string' && msg.trim().length > 0);
}

export function parseApiErrorMessage(
  data: ApiErrorBody | null | undefined,
  fallback = 'Something went wrong'
): string {
  if (!data) return fallback;

  const validationMessages = getValidationMessages(data);
  if (validationMessages.length > 0) {
    return validationMessages.join('. ');
  }

  if (typeof data.error === 'string' && data.error.trim()) {
    return data.error.trim();
  }

  if (typeof data.message === 'string' && data.message.trim() && data.message.trim() !== 'Validation failed') {
    return data.message.trim();
  }

  if (typeof data.details === 'string' && data.details.trim()) {
    return data.details.trim();
  }

  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }

  return fallback;
}

export async function parseApiErrorResponse(
  response: Response,
  fallback = 'Something went wrong'
): Promise<string> {
  const errorData = await response.json().catch(() => null);
  return parseApiErrorMessage(errorData, fallback);
}
